import React, { useContext } from "react";
import { generatePath, Navigate, useSearchParams } from "react-router-dom";

import { PAGE_PATHS } from "config/routes";
import { SessionContext } from "contexts";

const IndexPage = () => {
  const { user } = useContext(SessionContext);
  const [searchParams] = useSearchParams();

  if (!user) {
    return (
      <Navigate
        to={{ pathname: generatePath(PAGE_PATHS.MEMBERSHIPS.BUY.EMAIL_PAGE), search: searchParams.toString() }}
      />
    );
  }

  return (
    <Navigate
      to={{ pathname: generatePath(PAGE_PATHS.MEMBERSHIPS.BUY.CHECKOUT_PAGE), search: searchParams.toString() }}
    />
  );
};

export default IndexPage;
